import { API_BASE_URL } from "../lib/config";
import type { User } from "../types/user";

export interface AuthResponse {
  token: string;
  user: User;
}

export async function loginApi(email: string, password: string): Promise<AuthResponse> {
  const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || "Login failed");
  }
  return data;
}

export async function signupApi(
  email: string,
  password: string,
  name: string,
  quiz_industry?: string,
  quiz_challenges?: string
): Promise<AuthResponse> {
  const response = await fetch(`${API_BASE_URL}/api/auth/signup`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password, name, quiz_industry, quiz_challenges }),
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || "Signup failed");
  }
  return data;
}

export async function googleLoginApi(
  credential: string,
  quiz_industry?: string,
  quiz_challenges?: string
): Promise<AuthResponse> {
  const response = await fetch(`${API_BASE_URL}/api/auth/google`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ credential, quiz_industry, quiz_challenges }),
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || "Google authentication failed");
  }
  return data;
}

export async function fetchCurrentUserApi(token: string): Promise<User> {
  const response = await fetch(`${API_BASE_URL}/api/auth/me`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || "Failed to fetch current user session");
  }
  return data;
}
